const commonGetter = {
  getDepts(state) {
    return state.depts;
  },
  getZdDepts(state) {
    return state.zdDepts;
  },
  getTransferDepts(state) {
    return state.transferDepts;
  },
  getCaseReasons(state) {
    return state.caseReasons;
  },
  getDocUseTypes(state) {
    return state.docUseTypes;
  },

  getDocStockStats(state) {
    return state.docStockStats;
  },
  getDocUseStats(state) {
    return state.docUseStats;
  },

  getDeptUsers(state) {
    return state.deptUsers;
  },

  getDocCatalogs(state) {
    return state.docCatalogs;
  },

  getAllDocCatalogs(state) {
    return state.allDocCatalogs;
  },

  getDocInRecords(state) {
    return state.docInRecords;
  },
  getDocInCodeSequence(state) {
    return state.docInCodeSequence;
  },

  getDocOutRecords(state) {
    return state.docOutRecords;
  },
  getDocOutDocCatalogs(state) {
    return state.docOutDocCatalogs;
  },

  getDocReceiveRecords(state) {
    return state.docReceiveRecords;
  },
  getDocReceiveDocCatalogs(state) {
    return state.docReceiveDocCatalogs;
  },

  getDocs(state) {
    return state.docs;
  },
  getDocFeedbacks(state) {
    return state.docFeedbacks;
  },

  getCases(state) {
    return state.cases;
  },
  getMyCases(state) {
    return state.myCases;
  },
  getReceiveCases(state) {
    return state.receiveCases;
  },
  getCaseDetails(state) {
    return state.caseDetails;
  }
}

export default commonGetter;



// WEBPACK FOOTER //
// ./src/store/sczdzf/getters/commonGetter.js